// import AdvancedSelect from '@myena/advanced-select';
import vSelect from 'vue-select'
import axios from '../../common/axios.js'
import _ from 'lodash'
import Input from '../../common/forms/Input.vue'
import Select from '../../common/forms/Select.vue'
import Phone from '../../common/forms/Phone.vue'
import LoadingBtn from '../../common/ui/loading_btn.vue'
import Utils from '../../common/utils.js'

export default {
	mixins: [Utils],
	data(){
		return {
			civilite_options: [
				{label: this.$t('M.'), value: 'mr'},
				{label: this.$t('Mme'), value: 'mme'},
			],
			gender: 'mr',
			nom: '',
			prenom: '',
			email: '',
			email_confirm: '',
			tel: '',
			passwordType: 'password',
			passwordBType: 'password',
			password: '',
			password_b: '',
			entreprise: '',
			fonction: '',
			accepte: false,
			validation: false,
			error: false,
			tel_validation: {},
			errors: {},
			loading: false
		}
	},
	methods:{
		switchInput(){
			this.passwordType = this.passwordType == 'password' ? 'text' : 'password'
		},
		switchInputB(){
			this.passwordBType = this.passwordBType == 'password' ? 'text' : 'password'
		},
		submit(){
			console.log('test ????');
			var self = this;
			// var fields = ['nom', 'prenom', 'email', 'password', 'password_b', 'entreprise', 'fonction', 'accepte'];
			var fields = ['nom', 'prenom', 'email', 'email_confirm', 'password', 'password_b', 'fonction', 'tel'];
			self.errors = {};
			self.error = false;

			self.validation = true
			
			//AS--> Vérifie tous les champs
			fields.forEach(function(field){
				if(_.isString(self[field])){
					if(field == 'password' && !self.validatePwdStrong(self[field])){
						self.errors[field] = "--erreur--";
					}
					if(field == 'password_b' && self.password != self[field]){
						self.errors[field] = self.$t('signin_error_password_confirmation');
					}
					if(field == 'email' && !self.validateEmail(self[field])){
						self.errors[field] = self.$t('signin_error_email');
					}
					if(field == 'email_confirm' && self[field] != self.email){
						self.errors[field] = self.$t('signin_error_email_confirmation');
					}
					if(self[field].length == 0){
						self.errors[field] = self.$t('signin_error_empty');
					}
				}
				if(_.isBoolean(self[field]) && self[field] === false){
					self.errors[field] = self.$t('signin_error_cgu');
				}
				if(field == 'tel' && !self.validateTel(self[field])){
					self.errors[field] = self.$t('signin_error_tel');
				}
			})


			//AS--> S'il n'y a pas d'erreur, on poursuit l'inscription
			if(_.isEmpty(self.errors)){
				this.loading = true;
				axios.post('/plugin_projet/plugin_projet_iannuaire/signin', {
					data:{
						Profil: {
							nom: self.nom,
							prenom: self.prenom,
							email: self.email,
							password: self.password,
							entreprise: self.entreprise,
							fonction: self.fonction,
							tel1: self.tel,
							gender: self.gender,
						}
					}
				})
					.then(function (response) {
						if (typeof response.data.erreurs != 'undefined') {
							let errors = [];
							_.forEach(response.data.erreurs, function (text, field) {
								if(typeof text == 'object'){
									_.forEach(text, function(text, field){
										errors.push(self.i18n(text));
									})
								}else{
									errors.push(self.i18n(text));									
								}
								
							})
							if(errors.length > 1){
								self.error = '<ul>' + errors.map(function(error){ return '<li>' + error + '</li>'; }).join('') + '</ul>';
							}else{
								self.error = '<p>'+errors.pop()+'</p>';
							}
						} else {

							//AS--> Mémorise le numéro de téléphone dans l'app
							var user = _.cloneDeep(self.$store.state.user.user);
							user.tel = self.tel;
							self.$store.commit('USER_SET_USER', user);

							if(self.$store.getters.canVerifyPhone){
								self.$store.commit('UI_SET_MODAL', {modal: 'phone_code'});
							}else if(self.$store.getters.canAddCompany){
								self.$store.commit('UI_SET_MODAL', {modal: 'signin_company'});
							}else{
								self.$store.commit('UI_SET_MODAL', {modal: 'signin_success'});
							}
							
							self.$store.commit('UI_SET_COMPANY', null)
							self.$store.commit('UI_SET_COMPANY_PREV', null);
							self.$store.commit('UI_SET_COMPANY_NEXT', null);
							self.$store.commit('UI_SET_COMPANY_ID', null)
							self.$store.dispatch('init_user_data', response.data);
						}
				}).catch(function (error) {})
				.finally(function () {
					self.loading = false;
				});
			}
		},
		validateEmail(email) {
			var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		},
		validatePwdLen(password) {
			return password.length >= 8;
		},
		validatePwdStrong(password) {
			return this.password_validator.all
		},
		validateTel() {
			return this.tel_validation.valid === true
		},
		phoneValidation(validation){
			this[validation.field+'_validation'] = validation
		}
	},
	computed:{
		password_validator(){
			let validations = this._passwordValidator(this.password)
			return validations
		}
	},
	components: {
		vSelect,
		Input,
		Select,
		Phone,
		LoadingBtn
	}
}
